module.exports = __webpack_public_path__ + "static/templates/bulk-upload-v2-en.2XwAknb.xlsx";